import { QuickBuyButton } from '@ori/presentation-components';
import { useMemo } from 'react';
import { NotifyMe } from "./NotifyMe";
import { useTranslations } from "../../context";
import { useProduct } from "../../hooks/internal";
import { getAddToBasketMethod } from "../../utils/internal";
import { jsx as _jsx } from "react/jsx-runtime";
export var BuyOrNotifyMe = function BuyOrNotifyMe() {
  var _useProduct = useProduct(),
    analyticsData = _useProduct.analyticsData,
    buttons = _useProduct.buttons,
    code = _useProduct.code,
    hasEnoughPoints = _useProduct.hasEnoughPoints,
    name = _useProduct.name,
    currentFormatted = _useProduct.price.currentFormatted,
    tenant = _useProduct.tenant,
    onQuickBuyButtonClick = _useProduct.onQuickBuyButtonClick,
    onNotifyMeButtonClick = _useProduct.onNotifyMeButtonClick;
  var _ref = buttons !== null && buttons !== void 0 ? buttons : {},
    notifyMe = _ref.notifyMe,
    quickBuyButton = _ref.quickBuy;
  var _useTranslations = useTranslations(),
    quickBuy = _useTranslations.quickBuy;
  var addToBasketMethod = useMemo(function () {
    return getAddToBasketMethod(hasEnoughPoints);
  }, [hasEnoughPoints]);
  if (quickBuyButton !== null && quickBuyButton !== void 0 && quickBuyButton.enabled) {
    return /*#__PURE__*/_jsx(QuickBuyButton, {
      smallerOnMobile: true,
      ariaLabel: quickBuy,
      currentPrice: currentFormatted,
      currentProductCode: code,
      name: name,
      addToBasketMethod: addToBasketMethod,
      placement: analyticsData === null || analyticsData === void 0 ? void 0 : analyticsData.placement,
      position: analyticsData === null || analyticsData === void 0 ? void 0 : analyticsData.position,
      tenant: tenant,
      onQuickBuyButtonClick: quickBuyButton.trigger ? onQuickBuyButtonClick : undefined
    });
  }
  if (notifyMe !== null && notifyMe !== void 0 && notifyMe.enabled) {
    return /*#__PURE__*/_jsx(NotifyMe, {
      code: code,
      onNotifyMeButtonClick: notifyMe.trigger ? onNotifyMeButtonClick : undefined
    });
  }
  return null;
};
//# sourceMappingURL=BuyOrNotifyMe.js.map